import React from 'react';
import Popup from '@components/Popup';
import styles from './index.module.css';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function DialogWithPhoto(props) {
  const {
    titleTextComponent,
    titleText,
    titleImage,
    titleImageClassName,
    visible,
    customTitleClassName,
    customMessageClassName,
    wrapperMessageClassName,
    customBodyStyle,
    customContentStyle, MessagesComponent,
    ...other
  } = props;

  const renderTitle = () => {
    return (
      <div className={styles.titleContainer}>
        <img
          src={titleImage}
          className={classNames(styles.titleImage, titleImageClassName)}
          alt=""
        />
        {titleTextComponent ? (
          titleTextComponent
        ) : (
          <div className={classNames(styles.titleText, customTitleClassName)}>{titleText}</div>
        )}
      </div>
    );
  };

  return (
    <Popup
      visible={visible}
      TitleComponent={renderTitle()}
      titleClassName={styles.title}
      MessagesComponent={MessagesComponent}
      messageClassName={classNames(styles.messageClassName, customMessageClassName)}
      messagesContainerAddClass={wrapperMessageClassName}
      bodyStyle={classNames("pb-13-px", customBodyStyle)}
      customContentStyle={customContentStyle}
      disableClose
      {...other}
    />
  );
}

DialogWithPhoto.propTypes = {
  TitleComponent: PropTypes.element,
  visible: PropTypes.bool
};

export default DialogWithPhoto;
